import { render, staticRenderFns } from "./AddAddressPop.vue?vue&type=template&id=caabd120&scoped=true&"
import script from "./AddAddressPop.vue?vue&type=script&lang=js&"
export * from "./AddAddressPop.vue?vue&type=script&lang=js&"
import style0 from "./AddAddressPop.vue?vue&type=style&index=0&id=caabd120&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caabd120",
  null
  
)

export default component.exports